import type { ISerialize } from '@/objects/ISerialize';

export class BibAssignSaveResponse implements ISerialize {
    public BlockedBibIds: number[];

    public CategoryIds: number[];

    public EventIds: number[];

    public GroupIds: number[];

    public SortIds: number[];

    public Success: boolean;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: {
        BlockedBibIds?: number[];
        CategoryIds?: number[];
        EventIds?: number[];
        GroupIds?: number[];
        SortIds?: number[];
        Success?: boolean;
    }) {
        this.BlockedBibIds = values.BlockedBibIds ?? [];

        this.CategoryIds = values.CategoryIds ?? [];

        this.EventIds = values.EventIds ?? [];

        this.GroupIds = values.GroupIds ?? [];

        this.SortIds = values.SortIds ?? [];

        this.Success = values.Success ?? false;
    }

    public serialize(): string {
        return (
            '{' +
            `"BlockedBibIds": [ ${this.BlockedBibIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"CategoryIds": [ ${this.CategoryIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"EventIds": [ ${this.EventIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"GroupIds": [ ${this.GroupIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"SortIds": [ ${this.SortIds.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"Success": ${JSON.stringify(this.Success)}` +
            '}'
        );
    }

    /**
     * Creates an instance of BibAssignSaveResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: {
        BlockedBibIds?: number[];
        CategoryIds?: number[];
        EventIds?: number[];
        GroupIds?: number[];
        SortIds?: number[];
        Success?: boolean;
    }): BibAssignSaveResponse {
        return new BibAssignSaveResponse(values);
    }

    public static _FromServerJson(json: any): BibAssignSaveResponse {
        return new BibAssignSaveResponse({
            BlockedBibIds: json.BlockedBibIds,
            CategoryIds: json.CategoryIds,
            EventIds: json.EventIds,
            GroupIds: json.GroupIds,
            SortIds: json.SortIds,
            Success: json.Success,
        });
    }

    /**
     * Creates an instance of BibAssignSaveResponse from another instance of BibAssignSaveResponse.
     * @param other The BibAssignSaveResponse you want to clone
     * @returns A cloned BibAssignSaveResponse
     */
    public static FromOther(other: BibAssignSaveResponse): BibAssignSaveResponse {
        return BibAssignSaveResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return BibAssignSaveResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'BibAssignSaveResponse';
}
